import Sidebar from '../components/sidebar/Sidebar';
import Navbar from '../components/navbar/Navbar';
import React, {useState} from 'react';
import HeroSection from '../components/hero/HeroSection';
import {Pricing, Features, Testimonials} from '../components/InfoSection/Data';
import Forms from '../components/forms/Forms';
import Footer from '../components/footer/Footer';
import FeaturesSection from '../components/features/Features';
import PricingSection from '../components/pricing/PricingSection';
import Contact from "../components/contact/contact";
import TestimonialsSection from "../components/testimonials/TestimonialsSection";


const Home = () => {

    const [isOpen, setIsOpen] = useState(false);


    const toggle = () => {
        setIsOpen(!isOpen);
    }




    return (
      <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <Navbar toggle={toggle} />
        <HeroSection />
        <PricingSection {...Pricing} />
        <FeaturesSection {...Features} toggle={toggle}/>
        <Forms/>
        <TestimonialsSection {...Testimonials}/>
        <Contact/>
        <Footer/>
      </>
  );
};

export default Home;
